import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { getLLMConfig, selectLLMConfig, selectLLMConfigError, selectLLMConfigIsLoading } from '../feature';

export const useGetLLMConfig = ({ channelId }: { channelId?: number }) => {
  const isLoading = useAppState(selectLLMConfigIsLoading);
  const llmConfig = useAppState(selectLLMConfig);
  const error = useAppState(selectLLMConfigError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelId) return;
    dispatch(getLLMConfig({ channelId }));
  }, [channelId, dispatch]);

  return {
    isLoading,
    llmConfig,
    error,
  };
};
